module.exports = __webpack_public_path__ + "img/23.400e2dd1.png";